import _defineProperty from "/Users/joshthomas/Workspace/ionic-react-conference-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/Users/joshthomas/Workspace/ionic-react-conference-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/joshthomas/Workspace/ionic-react-conference-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/joshthomas/Workspace/ionic-react-conference-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/joshthomas/Workspace/ionic-react-conference-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/joshthomas/Workspace/ionic-react-conference-app/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import { IonTabBarInner, IonTabButton } from '../index';
import { withRouter } from 'react-router';

var IonTabBar =
/*#__PURE__*/
function (_Component) {
  _inherits(IonTabBar, _Component);

  function IonTabBar(props) {
    var _this;

    _classCallCheck(this, IonTabBar);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(IonTabBar).call(this, props));

    _this.onTabButtonClick = function (e) {
      var targetUrl = _this.state.activeTab === e.detail.tab ? _this.state.tabs[e.detail.tab].originalHref : _this.state.tabs[e.detail.tab].currentHref;

      _this.props.history.push(targetUrl);
    };

    _this.renderChild = function (activeTab) {
      return function (child) {
        var href = child.props.tab === activeTab ? _this.props.location.pathname : _this.state.tabs[child.props.tab].currentHref;
        return React.cloneElement(child, {
          href: href,
          onIonTabButtonClick: _this.onTabButtonClick
        });
      };
    };

    var tabActiveUrls = {};
    React.Children.forEach(_this.props.children, function (child) {
      if (typeof child === 'object' && child.type === IonTabButton) {
        tabActiveUrls[child.props.tab] = {
          originalHref: child.props.href,
          currentHref: child.props.href
        };
      }
    });
    _this.state = {
      activeTab: null,
      tabs: tabActiveUrls
    };
    return _this;
  }

  _createClass(IonTabBar, [{
    key: "render",
    value: function render() {
      return React.createElement(IonTabBarInner, Object.assign({}, this.props, {
        selectedTab: this.state.activeTab
      }), React.Children.map(this.props.children, this.renderChild(this.state.activeTab)));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var activeTab = Object.keys(state.tabs).find(function (key) {
        var href = state.tabs[key].originalHref;
        return props.location.pathname.startsWith(href);
      });

      if (!activeTab || activeTab === state.activeTab && state.tabs[activeTab].currentHref === props.location.pathname) {
        return null;
      }

      return {
        activeTab: activeTab,
        tabs: Object.assign({}, state.tabs, _defineProperty({}, activeTab, {
          originalHref: state.tabs[activeTab].originalHref,
          currentHref: props.location.pathname
        }))
      };
    }
  }]);

  return IonTabBar;
}(Component);

export default withRouter(IonTabBar);